/**
 * Type-safe constructor for a CommandModule.
 *
 * Within a command file, this preserves the narrow `z.infer<typeof schema>`
 * type for the `execute` callback's `args` parameter. The returned value is
 * widened to the registry-side {@link CommandModule} so it can be aggregated
 * with sibling commands.
 *
 * @example
 * const schema = z.object({ selector: z.string() });
 *
 * export const clickBySelector = defineCommand({
 *   name: 'electron_click_by_selector',
 *   description: 'Click the first element matching the CSS selector.',
 *   schema,
 *   operationType: 'command',
 *   async execute(args, target) {
 *     // args is { selector: string } here — full IntelliSense.
 *     return runClick(args.selector, target);
 *   },
 * });
 */
export function defineCommand(definition) {
    return definition;
}
